(function () {
  'use strict';

  document.querySelectorAll('[data-product-form]').forEach(function (wrapper) {
    var variantsEl = wrapper.querySelector('[data-variants-json]');
    if (!variantsEl) return;
    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }
    var selects = wrapper.querySelectorAll('[data-option-select]');
    var idInput = wrapper.querySelector('[data-variant-id]');
    var priceEl = wrapper.querySelector('[data-price]');
    var compareEl = wrapper.querySelector('[data-compare-price]');
    var buyBtn = wrapper.querySelector('[data-add-to-cart]');
    var moneyFormat = wrapper.getAttribute('data-money-format') || '\u00a3{{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
    }
    function currentVariant() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.find(function (v) { return chosen.every(function (val, i) { return v.options[i] === val; }); });
    }
    function update() {
      var variant = currentVariant();
      if (!variant) {
        if (buyBtn) { buyBtn.disabled = true; buyBtn.textContent = buyBtn.getAttribute('data-text-unavailable') || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      if (buyBtn) {
        if (variant.available) {
          buyBtn.disabled = false;
          buyBtn.textContent = buyBtn.getAttribute('data-text-add') || 'Add to cart';
        } else {
          buyBtn.disabled = true;
          buyBtn.textContent = buyBtn.getAttribute('data-text-soldout') || 'Sold out';
        }
      }
      if (variant.featured_image && variant.featured_image.src) {
        var mainImg = document.querySelector('[data-main-image]');
        if (mainImg) mainImg.src = variant.featured_image.src;
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(null, '', url.toString());
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  });

  var mainImage = document.querySelector('[data-main-image]');
  if (mainImage) {
    document.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        mainImage.src = btn.getAttribute('data-thumb');
        if (btn.getAttribute('data-alt')) mainImage.alt = btn.getAttribute('data-alt');
        document.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  document.querySelectorAll('.mobile-nav__panel a').forEach(function (link) {
    link.addEventListener('click', function () {
      var details = link.closest('details');
      if (details) details.removeAttribute('open');
    });
  });

  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var section = carousel.closest('section');
    var prevBtn = section && section.querySelector('[data-carousel-prev]');
    var nextBtn = section && section.querySelector('[data-carousel-next]');
    var perView = parseInt(carousel.getAttribute('data-per-view-desktop'), 10) || 4;
    track.style.setProperty('--per-view', perView);

    function scrollByOne(dir) {
      var slide = track.querySelector('.carousel__slide');
      if (!slide) return;
      var step = slide.getBoundingClientRect().width + 14;
      track.scrollBy({ left: step * dir, behavior: 'smooth' });
    }
    function updateButtons() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByOne(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByOne(1); });
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });

  document.querySelectorAll('[data-copy-code]').forEach(function (btn) {
    var hint = btn.querySelector('[data-copy-hint]');
    var originalHint = hint ? hint.textContent : '';
    btn.addEventListener('click', function () {
      var code = btn.getAttribute('data-code');
      if (!code) return;
      var done = function () {
        btn.classList.add('is-copied');
        if (hint) hint.textContent = 'Copied \u2713';
        setTimeout(function () {
          btn.classList.remove('is-copied');
          if (hint) hint.textContent = originalHint;
        }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(done);
      } else {
        var ta = document.createElement('textarea');
        ta.value = code; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta); done();
      }
    });
  });

  (function () {
    var STORAGE_KEY = 'floky_launch_dismissed';
    var banner = document.querySelector('[data-launch-banner]');
    if (!banner) return;
    try {
      if (localStorage.getItem(STORAGE_KEY) === '1') {
        banner.setAttribute('data-hidden', 'true');
        return;
      }
    } catch (e) {}
    var dismissBtn = banner.querySelector('[data-dismiss-banner]');
    if (!dismissBtn) return;
    dismissBtn.addEventListener('click', function () {
      banner.setAttribute('data-hidden', 'true');
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    });
  })();
})();
